import { MapPin } from 'lucide-react';

const OFFICES = [
  { city: 'Sydney', country: 'Australia' },
  { city: 'Auckland', country: 'New Zealand' },
  { city: 'Noida', country: 'India' },
];

const REACH = [
  { value: '500+', label: 'Retail Touchpoints' },
  { value: '8', label: 'Major Cities Covered' },
  { value: '2 Countries', label: '1 Partner' },
];

export const GlobalFootprint = () => (
  <section id="reach" className="py-20 md:py-32 bg-[#004aad] text-white">
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold mb-4">Global Footprint</h2>
        <p className="text-xl text-blue-100 max-w-2xl mx-auto">
          Globally connected, locally executed. With offices across continents.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
        {OFFICES.map((o) => (
          <div key={o.city} className="text-center">
            <div className="h-16 w-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="h-8 w-8" />
            </div>
            <h3 className="text-2xl font-bold mb-2">{o.city}</h3>
            <p className="text-blue-100">{o.country}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto pt-8 border-t border-white/20">
        {REACH.map((r) => (
          <div key={r.label} className="text-center">
            <div className="text-3xl font-bold mb-2">{r.value}</div>
            <p className="text-blue-100">{r.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
